export default "__VITE_ASSET__07b22d5a__"